module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"part_select.page.title":"รายการอะไหล่ที่สามารถเลือกได้","part_select.search_keyword.placeholder":"ค้นหาจาก SKU หรือ ชื่อ"}}')
  delete Component.options._Ctor
}
